import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import Button from '@App/kit/components/Buttons/Button'
import ModalPortal from '@App/kit/components/Popups/ModalPortal'
import Sidebar from '@App/kit/components/Sidebars/Sidebar'
import DownloadSidebar from '@Components/Sidebars/DownloadSidebar'
import { SidebarDownloadType } from '@App/enum/sidebar-download-type'
import ContentHeader from '@Components/ContentHeader'
import RoyaltiesStatementsFilter from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/RoyaltiesStatementsFilter'
import RoyaltiesStatementsTable from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/RoyaltiesStatementsTable'
import RoyaltiesStatementsContentHeader from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/RoyaltiesStatementsContentHeader'
import PointPreloader from '@Components/Preloaders/PointPreloader'
import { useOutletContext } from 'react-router'
import { analyticsSendPage } from '@App/common/utils/analytics-utils'
import { RoyaltiesStatementsContext } from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/hooks/useRoyaltiesStatements'

const RightsholderRoyaltiesStatements = () => {
    const { selectedPayee, selectedStatements, loading, setSidebarIsOpen, sidebarIsOpen } =
        useOutletContext<RoyaltiesStatementsContext>()

    useEffect(() => {
        analyticsSendPage('rightsholder_royalties_statement')
    }, [])

    return (
        <>
            <title>Royalty Statements</title>
            <div className="royalties-wrapper">
                <ContentHeader title="Royalty Statements" descriptionElement={<RoyaltiesStatementsContentHeader />} />
                <RoyaltiesStatementsFilter />
                {loading ? <PointPreloader /> : <RoyaltiesStatementsTable />}
                <div className="download-button">
                    <Button
                        mainColor
                        type="primary"
                        disabled={!selectedPayee || selectedStatements.length === 0}
                        onClick={() => setSidebarIsOpen(true)}
                    >
                        Continue to download
                    </Button>
                </div>
            </div>
            <ModalPortal isOpen={sidebarIsOpen} onClose={() => setSidebarIsOpen(false)}>
                <Sidebar onClose={() => setSidebarIsOpen(false)}>
                    <DownloadSidebar
                        closeSidebar={() => setSidebarIsOpen(false)}
                        downloadData={selectedStatements}
                        sidebarDownloadType={SidebarDownloadType.RoyaltyStatements}
                    />
                </Sidebar>
            </ModalPortal>
        </>
    )
}

export default observer(RightsholderRoyaltiesStatements)
